module.exports = __webpack_public_path__ + "img/img_4.73d818d3.png";